import { Component, OnInit, ViewChild, inject, DestroyRef } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ActivatedRoute } from '@angular/router';
import { catchError, EMPTY } from 'rxjs';
import { FormGroup, FormControl, Validators, ValidatorFn, FormBuilder, ReactiveFormsModule } from '@angular/forms';
import { FormFieldBase } from '../../classes/form-field-base';
import { FormFieldCheckbox } from '../../classes/form-field-checkbox'
import { Dictionary } from '../../classes/dictionary'
import { BrandService } from '../../services/brand/brand.service';
import { SharedService } from '../../services/shared.service';
import { ComponentSectionFactoryService } from '../../services/component-section-factory.service';
import { AccountBundleService } from '../../services/account/account-bundle.service';
import { HeaderSectionDirective } from '../../directives/header-section.directive';
import { FooterSectionDirective } from '../../directives/footer-section.directive';
import { BrandFooterComponent } from '../footer-sections/brand-footer/brand-footer.component';
import { DynamicFormFieldComponent } from '../section-blocks/dynamic-form-field/dynamic-form-field.component';
import { BrandHeaderComponent } from '../header-sections/brand-header/brand-header.component';
import { NGXLogger } from 'ngx-logger';

@Component({
    selector: 'app-account-bundle-selection',
    standalone: true,
    templateUrl: './account-bundle-selection.component.html',
    styleUrls: ['./account-bundle-selection.component.css'],
    imports: [BrandHeaderComponent, ReactiveFormsModule, DynamicFormFieldComponent, BrandFooterComponent]
})
export class AccountBundleSelectionComponent  implements OnInit {

  // @ViewChild(BrandHeaderComponent, {static : true}) brandHeader! : BrandHeaderComponent;    
  // @ViewChild(BrandFooterComponent, {static : true}) brandFooter! : BrandFooterComponent;    

  @ViewChild(HeaderSectionDirective, {static: true}) headerComponentSection!: HeaderSectionDirective;
  @ViewChild(FooterSectionDirective, {static: true}) footerComponentSection!: FooterSectionDirective;

    private readonly logger = inject(NGXLogger);
  private readonly destroyRef = inject(DestroyRef);

  formFields: FormFieldBase<string>[] | null = [];
  form!: FormGroup;

  brandStyleTheme: any = {};

  memberSelectionDict = new Dictionary();

  brandCode!: string;
  region!: string;
  sessionId!: string;

  successMessage!: string;
  errorMessage!: string;
  isSuccessMessageShown: boolean = false;
  isErrorMessageShown: boolean = false;

  constructor(
    private activatedRoute: ActivatedRoute,
    private brandService: BrandService,
    private sharedService: SharedService,
    private componentSectionFactoryService: ComponentSectionFactoryService,
    private accountBundleService: AccountBundleService) {
  }

  ngOnInit() {
    // Get the parameters from the caller (Walletron)
    this.activatedRoute.queryParamMap
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((params) => {
        this.region = params.get('r') || '';
        this.brandCode = params.get('bc') || '';
        this.sessionId = params.get('si') || '';
      });
 
    // Initialization of the form
    const fieldGroup: any = {};
    this.form = new FormGroup(fieldGroup);
    // Create form header and footer
//    this.makeHeaderAndFooter();
    //  Retrieve customer's notification preferences
//    this. getAccountMembers();
  }

  makeHeaderAndFooter() {
    this.brandService.getBrandInfo(this.region, this.brandCode)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(brandInfo => {
        if (brandInfo) {
          brandInfo.sectionText = 'Account Member Selection';
          // this.brandHeader.makeBrandHeader(response);
          // this.brandFooter.makeBrandFooter(response);
          this.brandStyleTheme = this.sharedService.getBrandStyleScheme(brandInfo);
          this.componentSectionFactoryService.loadHeaderSection(brandInfo, this.headerComponentSection);
          this.componentSectionFactoryService.loadFooterSection(brandInfo, this.footerComponentSection);
        }
      });
  }

  getAccountMembers() {
    // Make a web api call
    this.accountBundleService.getAccountMembers(this.region, this.sessionId)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(response => {
        this.formFields = [];
        if (response) {
        // Build dynamically notification preferences
        const fieldGroup: any = {};
        let validator: ValidatorFn[] = [Validators.required];
        response.forEach(element => {
          this.formFields?.push(new FormFieldCheckbox({
            key: element.memberName,
            label: element.memberDescription,
            checked:  element.defaultSelection,
            required: true,
            order: 1,
            controlType: 'checkbox',
          }));
          fieldGroup[element.memberName] = validator.length > 0 ? new FormControl(element.defaultSelection, validator)
                : new FormControl(element.defaultSelection);
          this.memberSelectionDict.set(element.memberName, element.defaultSelection); 
        });
        this.form = new FormGroup(fieldGroup);
      }
    });
  }

  onSubmit() {

    this.isSuccessMessageShown = false;
    this.isErrorMessageShown = false;
    this.accountBundleService.modifyAccountMembersSelection(
      this.region, this.sessionId, this.memberSelectionDict)
      .pipe(
        catchError(() => {
          return EMPTY;
        })
      )
      .subscribe({
        next: (reponse) => {
          this.successMessage = 'Your account memebers selection have been updated.';
          this.isSuccessMessageShown = true;
          let redirectUrl = '';
          window.location.href = redirectUrl;
        },
        error: (err) => {
          // this.logger.error('AccountBundleSelectionComponent - onSubmit', err);
          this.errorMessage = 'An error occured.  Please call system administrator.';
          this.isErrorMessageShown = true;
        },
      });
  }

  onClose() {
    // window.alert("hi");
    // window.opener = null; 
    // window.open('', '_self'); 
    window.open('','_parent','');
    window.close();
  }  

  changeMemberSelection(data: any) {
    if (this.memberSelectionDict.has(data.srcElement)) {
      this.memberSelectionDict.set(data.srcElement, data.checked)
    }
  }

}
